
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import OperatingDrawer from './OperatingDrawer.vue';
import {
  getYesterdayRange,
  getLast7DaysRange,
  getLast30DaysRange,
} from '@/common/utils';
import moment from 'moment';
import * as echarts from 'echarts';

@Component({
  components: {
    OperatingDrawer,
  },
})
export default class OperatingData extends Vue {
  @lazyInject(ShopService)
  shopService!: ShopService;

  @Ref('operatingDrawer')
  operatingDrawer!: OperatingDrawer;

  @Prop()
  shopId!: string;

  primaryType = '1';

  createTime: any = [];

  detailType = '';

  data = [];

  formDate: any = {};

  displayData = [
    'exposure_pv',
    'store_view_pv',
    'navi_pv',
    'route_pv',
    'intention_pv',
    'phone_call_order_cnt',
    'settle_cost',
    'order_cnt',
    'order_price',
  ];
  dataList: any[] = [];

  disabledDate(current: any) {
    // 防止 current 为 null
    if (!current) return false;

    const today = new Date();
    // 重置时间为 00:00:00，避免时分秒干扰
    const startOfDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );

    // 计算 90 天前（包含今天，所以是 89 天前？不，我们要包含 90 天）
    const minDate = new Date(startOfDay);
    minDate.setDate(startOfDay.getDate() - 90); // 90天前（含）到今天（含）共91天？看需求

    // const maxDate = startOfDay; // 今天

    // 禁用条件：小于最小日期 或 大于最大日期
    return current < minDate;
  }

  changeDate(val: any) {
    // console.log(val);
    const data = {
      shop_id: this.shopId,
      need_cycle: true,
      start_date: '',
      end_date: '',
    };
    this.primaryType = val;
    this.detailType = '';
    this.createTime = [];
    if (val === '0') {
      const { start, end } = getYesterdayRange();
      data.start_date = start;
      data.end_date = end;
      this.formDate = data;
      this.getShopData(data);
    } else if (val === '1') {
      const { start, end } = getLast7DaysRange();
      data.start_date = start;
      data.end_date = end;
      this.formDate = data;
      this.getShopData(data);
    } else if (val === '2') {
      const { start, end } = getLast30DaysRange();
      data.start_date = start;
      data.end_date = end;
      this.formDate = data;
      this.getShopData(data);
    }
  }

  async init() {
    const data = {
      shop_id: this.shopId,
      need_cycle: true,
      start_date: getLast7DaysRange().start,
      end_date: getLast7DaysRange().end,
    };
    this.createTime = [];
    this.primaryType = '1';
    this.formDate = data;
    this.getShopData(data);
  }

  async getShopData(data: any) {
    this.dataList = [];
    const res: any = await this.shopService.getShopReportData(data, this.$el);
    res.forEach((item: any) => {
      if (this.displayData.includes(item.column)) {
        this.dataList.push(item);
      }
    });
  }

  getQoute(val: any) {
    return val;
  }

  onChange(val: any) {
    const data = {
      shop_id: this.shopId,
      need_cycle: true,
      start_date: '',
      end_date: '',
    };
    this.primaryType = '3';
    this.detailType = '';
    if (!val.length) {
      this.createTime = [];
      // this.getShopData(data);
    } else {
      data.start_date = moment(val[0]).format('YYYY-MM-DD');
      data.end_date = moment(val[1]).format('YYYY-MM-DD');
      this.formDate = data;
      this.createTime = val;
      this.getShopData(data);
    }
  }

  comparisons(val: any, type: string) {
    if (!val.length) {
      return '';
    }
    const item = val[0];
    return item[type];
  }

  async getLineChart(item: any, title: string) {
    const data = { ...this.formDate, index_names: item };
    this.detailType = item;
    const res = await this.shopService.getShopReportDetail(data);
    const _data = this.structuralValue(res.series, item);
    const chartDom = document.getElementById('mainLine');
    const myChart = echarts.init(chartDom);
    const option = {
      title: {
        text: title,
      },
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: _data.x,
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: title,
          type: 'line',
          stack: 'Total',
          data: _data.y,
        },
      ],
    };

    option && myChart.setOption(option);
  }

  structuralValue(val: any, type: any) {
    const data: any = {
      x: [],
      y: [],
    };
    val.forEach((item: any) => {
      data.x.push(item.xcolumnValue);
      data.y.push(item.ycolumnValues[type].value);
    });
    return data;
  }

  more() {
    this.operatingDrawer.init();
  }
}
